import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900 px-4">
      <div className="max-w-md w-full text-center">
        <div className="text-7xl font-bold text-slate-300 dark:text-slate-700 mb-4">404</div>
        <h1 className="text-xl font-bold text-slate-900 dark:text-white mb-2">
          Pagina niet gevonden
        </h1>
        <p className="text-sm text-slate-500 dark:text-slate-400 mb-6">
          De pagina die je zoekt bestaat niet of is verplaatst.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-slate-800 dark:bg-slate-100 text-white dark:text-slate-900 text-sm font-medium hover:bg-slate-700 dark:hover:bg-slate-200 transition-colors"
        >
          <Home className="w-4 h-4" />
          Terug naar home
        </Link>
      </div>
    </div>
  );
}
